import { IFormControl } from '../../../../ui/forms/interfaces';
import store, { rootActions } from '../data/store';
import { scrollToFirstErrorControl, validateControl, validateForm } from '../../../../domain/validation/validation';
import { Dispatch } from 'react';

/**
 * the state is required when selected country has states
 */
export const isBillingStateRequired = (control?: IFormControl) => {
    const reduxStore = store.getState();
    if(!reduxStore || !reduxStore.root || !reduxStore.root.subscription) return true;

    const countries = reduxStore.root.countries;
    if(!countries) return true;

    const selectedCountryId = Number(reduxStore.root.countryIdControl.value) || 0;
    if(!selectedCountryId) return true;

    const selectedCountry = countries.find(country => country.countryID.toString() === selectedCountryId.toString());
    const countryHasStates = selectedCountry && selectedCountry.states && selectedCountry.states.length > 0;
    if(!countryHasStates) return true;

    const controlStateId = Number(control?.value) || 0;

    return countryHasStates && !!controlStateId;
};


export const validateBillingAddress = (billingFormFields: [IFormControl, string][], dispatch: Function) => {

    const billingAddressDispatch = (updatedControl: IFormControl, controlName: string) => {
        dispatch(
            rootActions.setControl({
                controlName,
                control: validateControl(updatedControl),
            })
        );
    };

    const formParams = billingFormFields.map(param => [
        param[0],
        (updatedControl: IFormControl) => billingAddressDispatch(updatedControl, param[1])
    ]) as  ([IFormControl, Dispatch<any>])[];

    const billingAddressErrorControls: IFormControl[] = [];
    const isBillingFormValidValid = validateForm(formParams, billingAddressErrorControls);

    if(!isBillingFormValidValid){
        scrollToFirstErrorControl(billingAddressErrorControls);
    }

    return isBillingFormValidValid;
};


export const getTaxIdMaxLength = () : number => {
    const reduxStore = store.getState();
    if(!reduxStore || !reduxStore.root) return Infinity;

    const countries = reduxStore.root.countries;
    if(!countries) return Infinity;

    const selectedCountryId = Number(reduxStore.root.countryIdControl.value) || 0;
    if(!selectedCountryId) return Infinity;

    const selectedCountry = countries.find(country => country.countryID.toString() === selectedCountryId.toString());
    const taxIdRequired = selectedCountry && selectedCountry.isTaxID;
    if(!taxIdRequired) return Infinity;

    const max = Number(selectedCountry.taxIDMaxLength) || 0;
    if(max <= 0) return Infinity;

    return max;
};


export const getTaxIdMinLength = () : number => {
    const reduxStore = store.getState();
    if(!reduxStore || !reduxStore.root) return 0;

    const countries = reduxStore.root.countries;
    if(!countries) return 0;

    const selectedCountryId = Number(reduxStore.root.countryIdControl.value) || 0;
    if(!selectedCountryId) return 0;

    const selectedCountry = countries.find(country => country.countryID.toString() === selectedCountryId.toString());
    const taxIdRequired = selectedCountry && selectedCountry.isTaxID;
    if(!taxIdRequired) return 0;

    const min = Number(selectedCountry.taxIDMinLength) || 0;
    if(min <= 0) return 0;

    return min;
};


export const isTaxIdRequired = (control?: IFormControl) => {
    const reduxStore = store.getState();
    if(!reduxStore || !reduxStore.root) return true;

    const value = control?.value || '';
    return !!value;
    //return reduxStore.root.taxIdSelectedStatusControl.value !== TaxIdStatusEnum.YES;
    /*
    const countries = reduxStore.root.countries;
    if(!countries) return true;

    const selectedCountryId = Number(reduxStore.root.countryIdControl.value) || 0;
    if(!selectedCountryId) return true;

    const selectedCountry = countries.find(country => country.countryID.toString() === selectedCountryId.toString());
    const taxIdRequired = selectedCountry && selectedCountry.isTaxID;
    if(!taxIdRequired) return true;

    const value = control?.value || '';
    return !!value;
     */
};


export const isTaxIdSelectedStatusRequired = (control?: IFormControl) => {
    const reduxStore = store.getState();
    if(!reduxStore || !reduxStore.root) return true;

    const countries = reduxStore.root.countries;
    if(!countries) return true;

    const selectedCountryId = Number(reduxStore.root.countryIdControl.value) || 0;
    if(!selectedCountryId) return true;

    const selectedCountry = countries.find(country => country.countryID.toString() === selectedCountryId.toString());
    const taxIdRequired = selectedCountry && selectedCountry.isTaxID;
    if(!taxIdRequired) return true;

    const taxIdSelectedStatus = Number(control?.value) || 0;
    return taxIdRequired && !!taxIdSelectedStatus;
};



